import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import CourseCard from "../components/CourseCard";
import BuyNowModal from "../components/BuyNowModal";
import { Search } from "lucide-react";

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("All");
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    document.title = "All Courses — Aducation | India's Most Affordable Learning Platform";
    api.get("/courses").then((r) => setCourses(r.data));
  }, []);

  const categories = useMemo(() => {
    const set = new Set(["All", ...courses.map((c) => c.category)]);
    return Array.from(set);
  }, [courses]);

  const filtered = courses.filter((c) => {
    const matchCat = category === "All" || c.category === category;
    const q = query.toLowerCase();
    const matchQ =
      !q ||
      c.title.toLowerCase().includes(q) ||
      (c.tags || []).some((t) => t.toLowerCase().includes(q)) ||
      c.short_description.toLowerCase().includes(q);
    return matchCat && matchQ;
  });

  return (
    <div data-testid="courses-page">
      <section className="relative overflow-hidden">
        <div className="hero-glow absolute inset-0 pointer-events-none" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-12 relative">
          <div className="text-xs uppercase tracking-[0.3em] text-amber-400 font-semibold mb-3">Explore Catalogue</div>
          <h1 className="font-display font-black text-4xl lg:text-6xl tracking-tighter">
            All <span className="red-text">Courses</span>
          </h1>
          <p className="mt-4 text-slate-400 max-w-2xl">
            Handpicked Govt Job prep + Job-ready Skills courses. All at ridiculously affordable prices.
          </p>

          <div className="mt-8 flex flex-col md:flex-row gap-3">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
              <input
                data-testid="courses-search-input"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search courses, tags, topics..."
                className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white placeholder:text-slate-500 focus:outline-none focus:border-amber-400/50"
              />
            </div>
            <div className="flex gap-2 flex-wrap">
              {categories.map((c) => (
                <button
                  key={c}
                  data-testid={`filter-cat-${c.toLowerCase()}`}
                  onClick={() => setCategory(c)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium border transition ${
                    category === c
                      ? "border-amber-400 bg-amber-400/10 text-amber-300"
                      : "border-white/10 text-slate-400 hover:border-white/30"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        {filtered.length === 0 ? (
          <div className="text-center py-20 text-slate-500">No courses found.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((c) => (
              <CourseCard
                key={c.id}
                course={c}
                onBuyNow={(course) => {
                  setSelected(course);
                  setModalOpen(true);
                }}
              />
            ))}
          </div>
        )}
      </section>

      <BuyNowModal open={modalOpen} onClose={() => setModalOpen(false)} course={selected} />
    </div>
  );
}
